import { ICON_DEFAULT_COLOR, ICON_DEFAULT_SIZE } from '@constants/icons';
import { IconProps } from '@models/icons';

function Info({ size = ICON_DEFAULT_SIZE, color = ICON_DEFAULT_COLOR, ...rest }: IconProps) {
    return (
        <svg width={size} height={size} viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg"
            {...rest} >
            <path
                d="M8.23312 2.93311C10.884 2.93311 13.0337 5.08211 13.0339 7.73291C13.0338 10.3838 10.884 12.5337 8.23312 12.5337C5.58246 12.5334 3.43343 10.3836 3.43332 7.73291C3.43351 5.08228 5.58251 2.93339 8.23312 2.93311ZM8.23312 3.80615C6.06451 3.80643 4.30656 5.56427 4.30637 7.73291C4.30648 9.90161 6.06446 11.6604 8.23312 11.6606C10.402 11.6606 12.1607 9.90179 12.1609 7.73291C12.1607 5.5641 10.402 3.80615 8.23312 3.80615ZM8.66965 9.91455H7.79758V7.29639H8.66965V9.91455ZM8.66965 6.42432H7.79758V5.55127H8.66965V6.42432Z"
                fill={color}/>
        </svg>
    );
}

export default Info;
